var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "#FFFFFF",
    stroke: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "moon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.9999 2.50007C10.1099 2.50007 10.2191 2.50007 10.3274 2.50007C9.25685 3.49483 8.56872 4.83328 8.38264 6.28276C8.19656 7.73224 8.52428 9.2011 9.30885 10.434C10.0934 11.6669 11.2852 12.5859 12.6771 13.0313C14.0689 13.4767 15.5728 13.4202 16.9274 12.8717C16.4063 14.1255 15.5547 15.2143 14.4634 16.022C13.3721 16.8296 12.0819 17.3259 10.7307 17.4579C9.37937 17.5899 8.01762 17.3525 6.79064 16.7712C5.56366 16.1899 4.51749 15.2865 3.76372 14.1572C3.00995 13.028 2.57686 11.7153 2.51064 10.3592C2.44442 9.00312 2.74755 7.65449 3.38771 6.45717C4.02787 5.25985 4.98103 4.25876 6.14554 3.56069C7.31004 2.86261 8.64219 2.49374 9.9999 2.49341V2.50007Z",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.91751fcd8d6a739ba6513d8cf6249c34.svg";
export { ForwardRef as ReactComponent };